/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/**
 * 分期商城授信状态轮询工具
 */
import { queryWithdrawResultSummary } from '@/api/rights/shop-mall';
import { WithdrawResultSummaryResponse } from '@/api/rights/shop-mall/types';
import { InstallMallCreditStatusEnum } from './types';

/**
 * 轮询配置
 */
interface PollingOptions {
  /** 来源 */
  from: string;
  /** 状态更新回调 */
  onStatusUpdate?: (status: InstallMallCreditStatusEnum) => void;
  /** 成功回调 */
  onSuccess?: (res: WithdrawResultSummaryResponse) => void;
  /** 失败回调 */
  onFailed?: () => void;
  /** 超时回调 */
  onTimeout?: () => void;
}

/**
 * 轮询状态管理
 */
export function pollingStatus(options: PollingOptions): {
  start: () => void;
  cancel: () => void;
} {
  const {
    // creditTaskId,
    from, onStatusUpdate, onSuccess, onFailed, onTimeout,
  } = options;

  let pollingTimer: number | null = null;
  let pollingCount = 0;
  const MAX_POLLING_COUNT = 60; // 最多轮询60次（60秒）

  /**
   * 停止轮询
   */
  const cancel = () => {
    if (pollingTimer) {
      clearInterval(pollingTimer);
      pollingTimer = null;
    }
    pollingCount = 0;
  };

  /**
   * 查询授信状态
   */
  const queryStatus = async () => {
    try {
      /** 查询概要接口去获取授信状态 */
      const result = await queryWithdrawResultSummary();
      if (result) {
        const { creditFrontStatus } = result;

        // 更新状态
        if (onStatusUpdate) {
          onStatusUpdate(creditFrontStatus);
        }

        // 授信成功
        if (creditFrontStatus === InstallMallCreditStatusEnum.CREDIT_SUCCESS) {
          /** 授信成功，停止轮询 */
          cancel();
          if (onSuccess) {
            onSuccess(result);
          }
          return;
        }

        // 授信失败
        if (creditFrontStatus === InstallMallCreditStatusEnum.CREDIT_FAIL) {
          cancel();
          if (onFailed) {
            onFailed();
          }
          return;
        }

        // 继续轮询（WAIT_CREDIT、CREDIT_PROCESSING）
      } else {
        /** 授信失败 */
        cancel();
        if (onFailed) {
          onFailed();
        }
        return;
      }
    } catch (error) {
      // 错误不中断轮询
    }

    // 检查是否超时
    pollingCount += 1;
    if (pollingCount >= MAX_POLLING_COUNT) {
      cancel();
      if (onTimeout) {
        onTimeout();
      }
    }
  };

  /**
   * 开始轮询
   */
  const start = () => {
    // 先停止之前的轮询
    cancel();

    // 立即执行一次
    queryStatus();

    // 每秒轮询一次
    pollingTimer = window.setInterval(() => {
      queryStatus();
    }, 1000);
  };

  return {
    start,
    cancel,
  };
}
